<template>
  <div>
    <PcbQoute parentSite="pcb" />
  </div>
</template>

<script>
import PcbQoute from '@@/views/pcbQuote/index'
export default {
  name: 'pcbQuote',
  components: {
    PcbQoute
  }
}
</script>

<style lang="scss" scoped>
</style>
